import { Material } from "@/models";
import axios from "axios";

export default class MaterialService {
    public async GetMaterials(accountId: number): Promise<Material[]> { 
        const materials = (await axios.get(`materials/account/${accountId}`)).data;

        return materials;
    }
}
